module.exports = __webpack_public_path__ + "img/logo-wbg-footer-en.08160936.svg";